import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  ElementRef,
  forwardRef,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'lib-ds-form-field',
  templateUrl: './form-field.component.html',
  styleUrls: ['./form-field.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DsFormFieldComponent),
      multi: true,
    },
  ],
})
export class DsFormFieldComponent implements ControlValueAccessor {
  @Input() label: string = '';
  @Input() type: 'email' | 'text' | 'password' | 'date' | 'tel' | 'url' | 'number' =
    'text';
  @Input() placeholder: string = '';
  @Input() required: boolean = false;
  @Input() errorMessage?: string;
  @Input() hasError: boolean = false;
  @Input() id: string = '';
  @Input() autocomplete?: string;
  @Input() showPasswordToggle: boolean = false;

  @Output() inputChange = new EventEmitter<string>();
  @Output() passwordToggle = new EventEmitter<void>();

  @ViewChild('input', { static: false })
  inputElement?: ElementRef<HTMLInputElement>;

  value: string = '';
  hidePassword: boolean = true;
  disabled: boolean = false;

  private onChange: (value: string) => void = () => {};
  private onTouched: () => void = () => {};

  writeValue(value: string): void {
    this.value = value || '';
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onInputChange(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.value = target.value;
    this.onChange(this.value);
    this.inputChange.emit(this.value);
  }

  onBlur(): void {
    this.onTouched();
  }

  togglePasswordVisibility(): void {
    this.hidePassword = !this.hidePassword;
    if (this.inputElement) {
      this.inputElement.nativeElement.type = this.hidePassword
        ? 'password'
        : 'text';
    }
    this.passwordToggle.emit();
  }

  get inputType(): string {
    if (this.type === 'password' && this.showPasswordToggle) {
      return this.hidePassword ? 'password' : 'text';
    }
    return this.type;
  }
}
